// extracted by mini-css-extract-plugin
export default {"CreateRoleContent":"CreateRoleContent_CreateRoleContent__aFgzE"};